export const locationsData = [
  {
    id: 1,
    name: 'New York',
    slug: 'new-york',
    coordinates: { lat: 40.7128, lng: -74.0060 },
    state: 'NY'
  },
  {
    id: 2,
    name: 'Los Angeles',
    slug: 'los-angeles',
    coordinates: { lat: 34.0522, lng: -118.2437 },
    state: 'CA'
  },
  {
    id: 3,
    name: 'Miami',
    slug: 'miami',
    coordinates: { lat: 25.7617, lng: -80.1918 },
    state: 'FL'
  },
  {
    id: 4,
    name: 'Houston',
    slug: 'houston',
    coordinates: { lat: 29.7604, lng: -95.3698 },
    state: 'TX'
  },
  {
    id: 5,
    name: 'Phoenix',
    slug: 'phoenix',
    coordinates: { lat: 33.4484, lng: -112.0740 },
    state: 'AZ'
  },
  {
    id: 6,
    name: 'Philadelphia',
    slug: 'philadelphia',
    coordinates: { lat: 39.9526, lng: -75.1652 },
    state: 'PA'
  },
  {
    id: 7,
    name: 'San Diego',
    slug: 'san-diego',
    coordinates: { lat: 32.7157, lng: -117.1611 },
    state: 'CA'
  },
  {
    id: 8,
    name: 'Dallas',
    slug: 'dallas',
    coordinates: { lat: 32.7767, lng: -96.7970 },
    state: 'TX'
  },
  {
    id: 9,
    name: 'Atlanta',
    slug: 'atlanta',
    coordinates: { lat: 33.7490, lng: -84.3880 },
    state: 'GA'
  },
  {
    id: 10,
    name: 'Orlando',
    slug: 'orlando',
    coordinates: { lat: 28.5383, lng: -81.3792 },
    state: 'FL'
  },
  {
    id: 11,
    name: 'Boca Raton',
    slug: 'boca-raton',
    coordinates: { lat: 26.3683, lng: -80.1289 },
    state: 'FL'
  },
  {
    id: 12,
    name: 'Fort Lauderdale',
    slug: 'fort-lauderdale',
    coordinates: { lat: 26.1224, lng: -80.1373 },
    state: 'FL'
  }
];